export const getters = {
  getGroupName(state) {
    return state.groupName;
  },
};
